<script setup>
/* eslint-disable vue/require-v-for-key */
import { ref } from "vue";

const props = defineProps({
    showActions: {
        type: Boolean,
        default: false,
    },
    dataTest: {
        type: String,
        default: "",
    },
    list: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits([
    "click",
]);

const actionBlock = ref({});

const showDropdown = ref(false);

const positionTop = ref(0);
const positionLeft = ref(0);

function clickOutside() {
    showDropdown.value = false;
}

function toggleShowDropdown() {
    const elemData = actionBlock.value.getBoundingClientRect();
    positionTop.value = elemData.y + 25;
    positionLeft.value = elemData.x + 6;
    showDropdown.value = !showDropdown.value;
}

</script>

<template>
    <div v-click-outside="clickOutside" class="ml-3 d-flex flex-row justify-content-center">
        <div @click="toggleShowDropdown"
             class="dd-action ml-2"
             :data-test="dataTest"
             ref="actionBlock"
        >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 11.875C11.0355 11.875 11.875 11.0355 11.875 10C11.875 8.96447 11.0355 8.125 10 8.125C8.96447 8.125 8.125 8.96447 8.125 10C8.125 11.0355 8.96447 11.875 10 11.875Z"
                    fill="black"/>
                <path
                    d="M10 18.125C11.0355 18.125 11.875 17.2855 11.875 16.25C11.875 15.2145 11.0355 14.375 10 14.375C8.96447 14.375 8.125 15.2145 8.125 16.25C8.125 17.2855 8.96447 18.125 10 18.125Z"
                    fill="black"/>
                <path
                    d="M10 5.625C11.0355 5.625 11.875 4.78553 11.875 3.75C11.875 2.71447 11.0355 1.875 10 1.875C8.96447 1.875 8.125 2.71447 8.125 3.75C8.125 4.78553 8.96447 5.625 10 5.625Z"
                    fill="black"/>
            </svg>
            <Teleport to="body">
                <div
                    :style="`top: ${positionTop}px; left: ${positionLeft}px;`"
                    :data-test="dataTest"
                    class="dd-action--dropdown" :class="{'active': showDropdown}"
                >
                    <div v-for="(item, idx) in props.list">
                        <div
                            @click="emit('click', item.title.toLowerCase())"
                            class="action-item" :class="[item.class]"
                            :data-test="item.dataTest"
                        >
                            <span v-if="item.class === 'show-dot'">
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="5" cy="5" r="5" fill="#EB4247"/>
                                </svg>
                            </span>
                            {{ item.title }}
                        </div>
                        <div v-if="props.list.length -1 > idx" class="separator"></div>
                    </div>
                </div>
            </Teleport>
        </div>
    </div>
</template>

<style scoped>
.dd-action {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    color: #260045;
    align-self: center;
    cursor: pointer;
    position: relative;
}

.dd-action--dropdown {
    position: absolute;
    min-width: 165px;
    min-height: 32px;
    padding: 12px;
    top: 25px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    box-sizing: border-box;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    z-index: 10;
    display: none;
}

.action-item {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #260045;
    cursor: pointer;
}

.action-item.remove {
    color: #EB4247;
}

.dd-action--dropdown .action-item {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #260045;
}

.dd-action--dropdown .action-item.remove {
    color: #EB4247;
}

.dd-action--dropdown.active {
    display: block;
}

.separator {
    width: 90%;
    border: 1px solid #DDDDDD;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
    margin: 8px 0px;
}

.show-dot > span {
    margin-right: 8px;
}
</style>
